import advancedColorSectionIds from '../constants/advanced-color-section-ids';
import variableNames from '../constants/variable-names';
import overrideStrategies from '../constants/variable-override-strategies';
import {
  getPrimaryButtonVariableNames,
  getSecondaryButtonVariableNames,
} from './get-button-variable-names';

const BASE_VARIABLE_DESCRIPTORS = [
  {
    variableName: variableNames.BLOCK_BACKGROUND,
    sectionId: advancedColorSectionIds.GENERAL,
    withOpacity: false,
    withGradient: true,
    overrideStrategy: overrideStrategies.BLOCK_BACKGROUND_LAYER,
  },
  {
    variableName: variableNames.SITE_NAME,
    sectionId: advancedColorSectionIds.TYPOGRAPHY,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
  },
  {
    variableName: variableNames.HEADING_1,
    sectionId: advancedColorSectionIds.TYPOGRAPHY,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
  },
  {
    variableName: variableNames.HEADING_2,
    sectionId: advancedColorSectionIds.TYPOGRAPHY,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
  },
  {
    variableName: variableNames.HEADING_3,
    sectionId: advancedColorSectionIds.TYPOGRAPHY,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
  },
  {
    variableName: variableNames.HEADING_4,
    sectionId: advancedColorSectionIds.TYPOGRAPHY,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
  },
  {
    variableName: variableNames.HEADING_5,
    sectionId: advancedColorSectionIds.TYPOGRAPHY,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
  },
  {
    variableName: variableNames.HEADING_6,
    sectionId: advancedColorSectionIds.TYPOGRAPHY,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
  },
  {
    variableName: variableNames.BLOCKQUOTE,
    sectionId: advancedColorSectionIds.TYPOGRAPHY,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
  },
  {
    variableName: variableNames.PARAGRAPH,
    sectionId: advancedColorSectionIds.TYPOGRAPHY,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
  },
  {
    variableName: variableNames.LINK_TEXT,
    sectionId: advancedColorSectionIds.TYPOGRAPHY,
    withOpacity: true,
    overrideStrategy: overrideStrategies.LINK,
  },
  {
    variableName: variableNames.MARK_TEXT,
    sectionId: advancedColorSectionIds.TYPOGRAPHY,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
  },
  {
    variableName: variableNames.HEADER_PHONE,
    sectionId: advancedColorSectionIds.TYPOGRAPHY,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
  },
  {
    variableName: variableNames.NAV_LINK,
    sectionId: advancedColorSectionIds.NAV_LINKS,
    withOpacity: true,
    overrideStrategy: overrideStrategies.LINK,
  },
  {
    variableName: variableNames.NAV_LINK_ACTIVE,
    sectionId: advancedColorSectionIds.NAV_LINKS,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
  },
  {
    variableName: variableNames.FOOTER_NAV_LINK_TEXT,
    sectionId: advancedColorSectionIds.FOOTER_NAV_LINKS,
    withOpacity: true,
    overrideStrategy: overrideStrategies.LINK,
  },
  {
    variableName: variableNames.OVERLAY_BACKGROUND,
    sectionId: advancedColorSectionIds.MEDIA,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
  },
  {
    variableName: variableNames.BORDER,
    sectionId: advancedColorSectionIds.DECORATIVE_ELEMENTS,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
  },
  {
    variableName: variableNames.BLOCK_DIVIDER,
    sectionId: advancedColorSectionIds.DECORATIVE_ELEMENTS,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
  },
  {
    variableName: variableNames.FEATURE_ICON,
    sectionId: advancedColorSectionIds.DECORATIVE_ELEMENTS,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
  },
  {
    variableName: variableNames.DECORATION_BACKGROUND,
    sectionId: advancedColorSectionIds.DECORATIVE_ELEMENTS,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
    requiresTextDecoration: true,
  },
  {
    variableName: variableNames.SOCIAL_ICON,
    sectionId: advancedColorSectionIds.DECORATIVE_ELEMENTS,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SOCIAL_ICON,
  },
  {
    variableName: variableNames.CONTACT_ICON,
    sectionId: advancedColorSectionIds.DECORATIVE_ELEMENTS,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
  },
  {
    variableName: variableNames.INPUT_LABEL,
    sectionId: advancedColorSectionIds.FORM,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
  },
  {
    variableName: variableNames.INPUT_BORDER,
    sectionId: advancedColorSectionIds.FORM,
    withOpacity: true,
    overrideStrategy: overrideStrategies.INPUT_BORDER,
  },
  {
    variableName: variableNames.INPUT_TEXT,
    sectionId: advancedColorSectionIds.FORM,
    withOpacity: true,
    overrideStrategy: overrideStrategies.SIMPLE_HSLA,
  },
];

const getButtonVariableDescriptors = (activeButtonPreset) => {
  const [pbVariableNames] = getPrimaryButtonVariableNames(activeButtonPreset);
  const [sbVariableNames] = getSecondaryButtonVariableNames(activeButtonPreset);

  return [
    {
      variableName: pbVariableNames.PRIMARY_BUTTON_BACKGROUND,
      sectionId: advancedColorSectionIds.PRIMARY_BUTTON,
      withOpacity: true,
      overrideStrategy: overrideStrategies.PRIMARY_BUTTON_SURFACE,
    },
    {
      variableName: pbVariableNames.PRIMARY_BUTTON_TEXT,
      sectionId: advancedColorSectionIds.PRIMARY_BUTTON,
      withOpacity: true,
      overrideStrategy: overrideStrategies.PRIMARY_BUTTON_TEXT,
    },
    {
      variableName: pbVariableNames.PRIMARY_BUTTON_BORDER,
      sectionId: advancedColorSectionIds.PRIMARY_BUTTON,
      withOpacity: true,
      overrideStrategy: overrideStrategies.PRIMARY_BUTTON_SURFACE,
    },
    {
      variableName: sbVariableNames.SECONDARY_BUTTON_BACKGROUND,
      sectionId: advancedColorSectionIds.SECONDARY_BUTTON,
      withOpacity: true,
      overrideStrategy: overrideStrategies.SECONDARY_BUTTON_SURFACE,
    },
    {
      variableName: sbVariableNames.SECONDARY_BUTTON_TEXT,
      sectionId: advancedColorSectionIds.SECONDARY_BUTTON,
      withOpacity: true,
      overrideStrategy: overrideStrategies.SECONDARY_BUTTON_TEXT,
    },
    {
      variableName: sbVariableNames.SECONDARY_BUTTON_BORDER,
      sectionId: advancedColorSectionIds.SECONDARY_BUTTON,
      withOpacity: true,
      overrideStrategy: overrideStrategies.SECONDARY_BUTTON_SURFACE,
    },
  ];
};

const descriptorCache = new Map();

const getAdvancedColorVariableDescriptors = (activeButtonPreset = null) => {
  if (descriptorCache.has(activeButtonPreset)) return descriptorCache.get(activeButtonPreset);

  const descriptors = [
    ...BASE_VARIABLE_DESCRIPTORS,
    ...getButtonVariableDescriptors(activeButtonPreset),
  ];
  descriptorCache.set(activeButtonPreset, descriptors);
  return descriptors;
};

export default getAdvancedColorVariableDescriptors;
